import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Container = styled.div`
	width: 100%;
	max-height: 438px;
	overflow-y: auto;

	::-webkit-scrollbar {
		width: 4px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background: #888;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
`;

export const ContainerProgressBar = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ContainerProgressBarSkeleton = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;
